import { expenseDetailsService } from '../../../expenses/features/expense-details/expense-details.service';
import {
  TimeSheetDetailsGetters,
  TimeSheetDetailsActions,
  TimeSheetDetailsMutations
} from './time-sheet-details.keys';
import { timeSheetDetailsService } from './time-sheet-details.service';
import { attachmentService } from '../../../../components/attachments/attachment.service';
import { map, pick } from 'ramda';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';
import router from '@/router';

export const getDefaultState = () => {
  return {
    isLoading: true,
    currentTimeSheet: {
      contractor: {},
      approvers: [],
      assignment: {},
      timeSheetRates: [],
      timeSheetEntries: [],
      timeSheetNotes: [],
      approverComment: ''
    },
    attachments: [],
    timeSheetHistories: [],
    isLoadingAttachments: false
  };
};
export const timeSheetDetailsStore = {
  state: getDefaultState(),
  getters: {
    [TimeSheetDetailsGetters.IsLoading]: state => state.isLoading
  },
  mutations: {
    [TimeSheetDetailsMutations.ResetTimeSheetState]: function(state) {
      Object.assign(state, getDefaultState());
    },
    [TimeSheetDetailsMutations.SetLoading]: function(state, isLoading = true) {
      state.isLoading = isLoading;
    },
    [TimeSheetDetailsMutations.RetrieveTimeSheetSuccess]: function(state, timeSheet) {
      state.currentTimeSheet = timeSheet;
    },
    [TimeSheetDetailsMutations.SetAttachmentsLoading]: function(state, isLoading = true) {
      state.isLoadingAttachments = isLoading;
    },
    [TimeSheetDetailsMutations.RetrieveAttachmentsSuccess]: function(state, attachments) {
      state.attachments = attachments;
      state.isLoadingAttachments = false;
    },
    [TimeSheetDetailsMutations.RetrieveHistorySuccess]: function(state, histories) {
      state.timeSheetHistories = histories;
    },
    [TimeSheetDetailsMutations.ConfirmIbmEndClientSuccess]: (state, val) => {
      state.currentTimeSheet.is_ibm_endclient_confirmed = val;
    },
    [TimeSheetDetailsMutations.ChangeIbmEndClientSuccess]: (state, val) => {
      state.currentTimeSheet.replaced_end_client = val;
    }
  },
  actions: {
    [TimeSheetDetailsActions.ResetCurrentTimeSheet]: function({ commit, dispatch }) {
      dispatch(TolErrorsActions.ClearAll);
      commit(TimeSheetDetailsMutations.ResetTimeSheetState);
    },
    [TimeSheetDetailsActions.RetrieveTimeSheet]: function({ commit, dispatch }, referenceNumber) {
      commit(TimeSheetDetailsMutations.SetLoading);

      const detailsPromise = timeSheetDetailsService
        .retrieveTimeSheet(referenceNumber)
        .then(timeSheet => {
          commit(TimeSheetDetailsMutations.RetrieveTimeSheetSuccess, timeSheet);
          commit(TimeSheetDetailsMutations.SetLoading, false);
        });
      dispatch(TimeSheetDetailsActions.RetrieveTimeSheetAttachments, referenceNumber);
      return Promise.all([detailsPromise])
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.retrieveTimeSheet')
          });
        });
    },
    [TimeSheetDetailsActions.RetrieveTimeSheetAttachments]: function(
      { commit, dispatch },
      referenceNumber
    ) {
      commit(TimeSheetDetailsMutations.SetAttachmentsLoading);
      return attachmentService
        .getAttachments(referenceNumber, 'TIME_SHEET')
        .then(response => {
          dispatch(TolErrorsActions.ClearAll);
          commit(TimeSheetDetailsMutations.RetrieveAttachmentsSuccess, response.data);
        })
        .catch(error => {
          // api returns 404 if user is not allowed to see attachments,
          // but an empty array with status 200 if there are no attachments
          if (error.status === 404) return;
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.retrieveAttachments')
          });
        });
    },
    [TimeSheetDetailsActions.SaveTimeSheet]: function(
      { commit, state, dispatch },
      { action, approverComment, entries, notes }
    ) {
      commit(TimeSheetDetailsMutations.SetLoading);

      const prunedEntries = map(pick(['id', 'quantity']), entries);
      const prunedNotes = map(pick(['id', 'date', 'note']), notes);
      return timeSheetDetailsService
        .saveTimeSheetEntries(
          state.currentTimeSheet.referenceNumber,
          state.currentTimeSheet.replaced_end_client,
          action,
          approverComment,
          prunedEntries,
          prunedNotes
        )
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
          dispatch(
            TimeSheetDetailsActions.RetrieveTimeSheet,
            state.currentTimeSheet.referenceNumber
          );
          commit(TimeSheetDetailsMutations.SetLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.save')
          });
        });
    },
    [TimeSheetDetailsActions.TimeSheetApproverAction]: function(
      { commit, state, dispatch },
      { action, approverComment }
    ) {
      commit(TimeSheetDetailsMutations.SetLoading);

      return timeSheetDetailsService
        .approveRejectReopenTimeSheet(
          state.currentTimeSheet.referenceNumber,
          action,
          approverComment
        )
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
          dispatch(
            TimeSheetDetailsActions.RetrieveTimeSheet,
            state.currentTimeSheet.referenceNumber
          );
          commit(TimeSheetDetailsMutations.SetLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.approverAction')
          });
        });
    },
    [TimeSheetDetailsActions.ReopenTimeSheet]: function({ commit, state, dispatch }) {
      commit(TimeSheetDetailsMutations.SetLoading);

      return timeSheetDetailsService
        .approveRejectReopenTimeSheet(
          state.currentTimeSheet.referenceNumber,
          TimeSheetDetailsActions.ReopenTimeSheet
        )
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
          dispatch(
            TimeSheetDetailsActions.RetrievetimeSheet,
            state.currentTimeSheet.referenceNumber
          );
          commit(TimeSheetDetailsMutations.SetLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.reopen')
          });
        });
    },
    [TimeSheetDetailsActions.ExpenseAction]: function({ state, dispatch }) {
      expenseDetailsService
        .expenseForTimeSheet(state.currentTimeSheet.id)
        .then(response => {
          dispatch(TolErrorsActions.ClearAll);
          router.push('/expenses/' + response.data);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.expense')
          });
        });
    },
    [TimeSheetDetailsActions.ConfirmIbmEndClient]: ({ commit }, val) => {
      commit(TimeSheetDetailsMutations.ConfirmIbmEndClientSuccess, val);
    },
    [TimeSheetDetailsActions.ChangeIbmEndClient]: ({ commit }, val) => {
      commit(TimeSheetDetailsMutations.ChangeIbmEndClientSuccess, val);
    },
    [TimeSheetDetailsActions.RetrieveTimeSheetHistory]: ({ commit, dispatch }, referenceNumber) => {
      return timeSheetDetailsService
        .retrieveTimeSheetHistory(referenceNumber)
        .then(timeSheetHistories => {
          commit(TimeSheetDetailsMutations.RetrieveHistorySuccess, timeSheetHistories);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('timeSheets.details.errors.timeSheetHistory')
          });
        });
    }
  }
};
